/* FemiEko — paginile de categorie 2026 (fe-cat).
 * Filtrare, sortare, scurtături, ghid și selecția mărimii pe produsele randate de fe-cat-main.
 * Adăugarea în coș rămâne a temei (form is="product-form"); aici doar deschidem/închidem panourile.
 */
(function () {
  if (window.FeCat) return;
  const $ = (s, e) => (e || document).querySelector(s);
  const $$ = (s, e) => Array.from((e || document).querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const desktop = () => window.matchMedia('(min-width: 900px)').matches;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const split = (s) => (s || '').split(/\s+/).filter(Boolean);
  const fmt = (t, o) => String(t || '').replace(/\{(\w)\}/g, (m, k) => (o[k] != null ? o[k] : m));
  const RANGES = { '2XS-M': ['2XS', 'XS', 'S', 'M'], 'L-3XL': ['L', 'XL', '2XL', '3XL'] };
  const ORDER = ['12-14', '14-16', '3XS', '2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  const CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true" class="fc-chev"><path d="m6 9 6 6 6-6"/></svg>';
  const DROP = '<path d="M12 3C12 3 5.5 10.7 5.5 15.5a6.5 6.5 0 0 0 13 0C18.5 10.7 12 3 12 3Z"/>';
  const drops = (n) => '<span class="fc-drops" aria-hidden="true">' + [1, 2, 3, 4, 5, 6].map((i) => `<svg viewBox="0 0 24 24"${i <= n ? ' class="on"' : ''}>${DROP}</svg>`).join('') + '</span>';

  function sizeKeys(raw) {
    const v = raw.trim();
    const up = v.toUpperCase().replace(/\s+/g, '');
    if (RANGES[up]) return RANGES[up];
    const m = v.match(/^(\d{1,2})\s*[-–]\s*(\d{1,2})/);
    if (m) return [m[1] + '-' + m[2]];
    return [up];
  }

  class Cat {
    constructor(root) {
      this.root = root;
      this.cfg = JSON.parse($('[data-fc-config]', root).textContent);
      this.ui = this.cfg.ui;
      this.grid = $('[data-fc-grid]', root);
      this.toolbar = $('[data-fc-toolbar]', root);
      this.actives = $('[data-fc-actives]', root);
      this.empty = $('[data-fc-empty]', root);
      this.drawer = $('[data-fc-drawer]', root);
      this.sheet = $('[data-fc-sheet]', root);
      this.status = $('[data-fc-status]', root);
      this.shortcutsBox = $('[data-fc-shortcuts]', root);
      this.fromGuide = false;
      this.readCards();
      this.defs = this.buildDefs();
      this.state = this.fromURL();
      this.bind();
      this.syncSticky();
      this.render(false);
      root.fcCat = this;
    }

    // ---------- date ----------
    readCards() {
      this.cards = $$('[data-fc-card]', this.grid).map((el) => {
        if (el.fcCard) return el.fcCard;
        const d = el.dataset;
        const sizes = [];
        (d.sizes || '').split('|').filter(Boolean).forEach((x) => {
          const i = x.lastIndexOf('~');
          const raw = x.slice(0, i), av = x.slice(i + 1) === '1';
          const keys = sizeKeys(raw);
          keys.forEach((k) => {
            const e = sizes.find((s) => s.key === k);
            if (e) e.av = e.av || av;
            else sizes.push({ key: k, label: keys.length > 1 ? k : raw.trim(), av });
          });
        });
        const stockEl = $('[data-fc-stock]', el);
        const card = {
          el, cell: el.closest('.fc-cell'), id: d.id, index: +d.index, price: +d.price, name: d.name || '',
          available: d.available === '1', sizes,
          flux: split(d.flux), use: split(d.use), stil: split(d.stil), teen: d.teen ? ['teen'] : [],
          level: d.level ? [d.level] : [], ga: split(d.ga), gb: split(d.gb),
          stockEl, stockText: stockEl ? stockEl.textContent : '', stockClass: stockEl ? stockEl.className : '',
        };
        el.fcCard = card;
        return card;
      });
    }

    buildDefs() {
      const L = this.cfg.labels, ui = this.ui, groups = this.cfg.groups || [];
      const sizeLabels = {};
      this.cards.forEach((c) => c.sizes.forEach((s) => { if (!sizeLabels[s.key] || /\d-\d/.test(s.key)) sizeLabels[s.key] = s.label; }));
      const defs = {
        size: { id: 'size', label: ui.f_size, values: (c) => c.sizes.map((s) => s.key), label_of: (v) => sizeLabels[v] || v, order: ORDER },
        flux: { id: 'flux', label: ui.f_flux, values: (c) => c.flux, label_of: (v) => L.flux[v] || v, order: Object.keys(L.flux) },
        level: { id: 'level', label: ui.f_level, values: (c) => c.level, label_of: (v) => L.level[v] || v, order: ['2', '3', '4', '5', '6'], drops: true },
        stil: { id: 'stil', label: ui.f_stil, values: (c) => c.stil, label_of: (v) => L.stil[v] || v, order: Object.keys(L.stil) },
        use: { id: 'use', label: ui.f_use, values: (c) => c.use, label_of: (v) => L.use[v] || v, order: Object.keys(L.use) },
        teen: { id: 'teen', label: L.teen.teen, values: (c) => c.teen, label_of: () => L.teen.teen, order: ['teen'], hidden: true },
        stock: { id: 'stock', label: ui.stock_only, toggle: true },
      };
      ['ga', 'gb'].forEach((set) => {
        const gs = groups.filter((g) => g.set === set);
        defs[set] = { id: set, label: this.cfg.groupLabel[set] || '', values: (c) => c[set], label_of: (v) => (gs.find((g) => g.key === v) || {}).name || v, order: gs.map((g) => g.key) };
      });
      return defs;
    }

    visibleDefs() { return (this.cfg.filters || []).map((id) => this.defs[id]).filter(Boolean); }

    matches(c, st, except) {
      const sizeSel = st.f.size || [];
      const stockOnly = (st.f.stock || []).length > 0;
      for (const id of Object.keys(st.f)) {
        const sel = st.f[id];
        if (!sel || !sel.length || id === except) continue;
        if (id === 'stock') { if (sizeSel.length && except !== 'size') continue; if (!c.available) return false; continue; }
        if (id === 'size') { if (!c.sizes.some((s) => sel.includes(s.key) && (!stockOnly || s.av))) return false; continue; }
        const def = this.defs[id];
        if (!def) continue;
        if (!def.values(c).some((v) => sel.includes(v))) return false;
      }
      return true;
    }

    facet(def) {
      const vals = new Set();
      this.cards.forEach((c) => def.values(c).forEach((v) => vals.add(v)));
      const base = this.cards.filter((c) => this.matches(c, this.state, def.id));
      const order = def.order || [];
      return Array.from(vals).sort((a, b) => ((order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99)) || String(a).localeCompare(String(b))).map((v) => ({
        value: v, label: def.label_of(v), count: base.filter((c) => def.values(c).includes(v)).length, checked: (this.state.f[def.id] || []).includes(v),
      }));
    }

    activeCount() { return Object.values(this.state.f).reduce((n, v) => n + (v ? v.length : 0), 0); }

    plural(n) {
      const u = this.ui, L = this.cfg.lang;
      if (n === 1) return u.p1;
      if (L === 'pl') { const a = n % 10, b = n % 100; return a >= 2 && a <= 4 && (b < 12 || b > 14) ? u.p2 : u.p5; }
      if (L === 'el') return u.p2;
      const b = n % 100;
      return n === 0 || (b >= 1 && b <= 19) ? u.p2 : u.p5;
    }

    // ---------- URL ----------
    fromURL() {
      const q = new URLSearchParams(location.search);
      const st = { f: {}, sort: q.get('fe_sort') || 'manual' };
      Object.keys(this.defs).forEach((id) => { const v = q.get('fe_' + id); if (v) st.f[id] = v.split(',').filter(Boolean); });
      return st;
    }
    toURL(push) {
      const q = new URLSearchParams(location.search);
      Array.from(q.keys()).filter((k) => k.startsWith('fe_')).forEach((k) => q.delete(k));
      Object.keys(this.state.f).forEach((id) => { const v = this.state.f[id]; if (v && v.length) q.set('fe_' + id, v.join(',')); });
      if (this.state.sort && this.state.sort !== 'manual') q.set('fe_sort', this.state.sort);
      const url = location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash;
      history[push ? 'pushState' : 'replaceState'](history.state, '', url);
    }

    // ---------- randare ----------
    render(push, opts) {
      opts = opts || {};
      const openPop = $('.fc-pop__btn[aria-expanded="true"]', this.root);
      const openId = openPop ? openPop.closest('.fc-pop').dataset.pop : null;
      const focus = document.activeElement && this.root.contains(document.activeElement) ? this.focusKey(document.activeElement) : null;
      const list = this.sorted(this.cards.filter((c) => this.matches(c, this.state)));
      // ordinea și vizibilitatea cardurilor
      const show = new Set(list.map((c) => c.id));
      this.sorted(this.cards).forEach((c) => { c.cell.hidden = !show.has(c.id); });
      list.concat(this.cards.filter((c) => !show.has(c.id))).forEach((c) => this.grid.appendChild(c.cell));
      this.grid.classList.toggle('is-filtering', this.activeCount() > 0);
      this.updateStock();
      this.renderToolbar(list.length);
      this.renderActives();
      this.renderShortcuts();
      this.renderEmpty(list.length);
      if (this.drawer.open) this.renderDrawer(list.length);
      this.toURL(push);
      if (openId && opts.keepPop) this.openPop($(`.fc-pop[data-pop="${openId}"]`, this.root));
      if (focus) this.restoreFocus(focus);
      if (opts.announce) this.announce(fmt(this.ui.announce, { n: list.length + ' ' + this.plural(list.length) }));
      if (window.FeCatGuide) window.FeCatGuide.update();
      return list;
    }

    sorted(arr) {
      const s = this.state.sort;
      const a = arr.slice();
      if (s === 'price-ascending') a.sort((x, y) => x.price - y.price || x.index - y.index);
      else if (s === 'price-descending') a.sort((x, y) => y.price - x.price || x.index - y.index);
      else if (s === 'title-ascending') a.sort((x, y) => x.name.localeCompare(y.name, this.cfg.lang) || x.index - y.index);
      else a.sort((x, y) => x.index - y.index);
      return a;
    }

    updateStock() {
      const sel = this.state.f.size || [];
      this.cards.forEach((c) => {
        if (!c.stockEl) return;
        if (!sel.length || !c.available || !c.sizes.length) { c.stockEl.textContent = c.stockText; c.stockEl.className = c.stockClass; return; }
        const hit = c.sizes.filter((s) => sel.includes(s.key));
        const ok = hit.filter((s) => s.av).map((s) => s.label), no = hit.filter((s) => !s.av).map((s) => s.label);
        if (!ok.length && no.length) { c.stockEl.textContent = fmt(this.ui.sizes_out, { s: no.join(', ') }); c.stockEl.className = 'fc-stock fc-stock--low'; }
        else if (ok.length) { c.stockEl.textContent = fmt(this.ui.sizes_in, { s: ok.join(', ') }); c.stockEl.className = 'fc-stock fc-stock--in'; }
      });
    }

    showFilters() { return this.cards.length >= (this.cfg.minFilters || 6) && this.visibleDefs().some((d) => !d.toggle && this.facet(d).length > 1); }

    filterControl(def, ctx) {
      const opts = this.facet(def);
      if (opts.length < 2 && !(this.state.f[def.id] || []).length) return '';
      const id = `fc-${ctx}-${def.id}-${this.cfg.sectionId}`;
      const isSize = def.id === 'size';
      const boxes = opts.map((o) => {
        const dis = !o.count && !o.checked;
        return `<label class="fc-opt${isSize ? ' fc-opt--size' : ''}${dis ? ' is-dis' : ''}"><input type="checkbox" value="${esc(o.value)}" data-fc-filter="${def.id}"${o.checked ? ' checked' : ''}${dis ? ' disabled' : ''}><span class="fc-opt__box" aria-hidden="true"></span><span class="fc-opt__l">${def.drops ? drops(+o.value) : ''}${esc(o.label)}</span><span class="fc-opt__n">${o.count}</span></label>`;
      }).join('');
      const sel = (this.state.f[def.id] || []).length;
      const help = isSize && this.cfg.sizeNote ? `<p class="fc-help">${esc(this.cfg.sizeNote)}</p>` : '';
      if (ctx === 'dr') return `<fieldset class="fc-dr-group"><legend>${esc(def.label)}${sel ? ` <span class="fc-count">${sel}</span>` : ''}</legend><div class="fc-opts${isSize ? ' fc-opts--size' : ''}">${boxes}</div>${help}</fieldset>`;
      return `<div class="fc-pop" data-pop="${def.id}"><button type="button" class="fc-pop__btn${sel ? ' is-on' : ''}" aria-expanded="false" aria-controls="${id}">${esc(def.label)}${sel ? ` <span class="fc-count">${sel}<span class="fc-sr"> ${esc(this.ui.selected)}</span></span>` : ''}${CHEV}</button><div class="fc-pop__panel" id="${id}" hidden><fieldset><legend class="fc-sr">${esc(def.label)}</legend><div class="fc-opts${isSize ? ' fc-opts--size' : ''}">${boxes}</div></fieldset>${help}</div></div>`;
    }

    sortSelect(ctx) {
      const u = this.ui;
      const opts = [['manual', u.sort_manual], ['price-ascending', u.sort_price_asc], ['price-descending', u.sort_price_desc], ['title-ascending', u.sort_alpha]];
      return `<label class="fc-sort"><span>${esc(u.sort)}</span><select data-fc-sort id="fc-sort-${ctx}-${this.cfg.sectionId}">${opts.map((o) => `<option value="${o[0]}"${this.state.sort === o[0] ? ' selected' : ''}>${esc(o[1])}</option>`).join('')}</select>${CHEV}</label>`;
    }

    renderToolbar(n) {
      const u = this.ui;
      const count = `<p class="fc-count-total" data-fc-count tabindex="-1"><strong>${n}</strong> ${esc(this.plural(n))}</p>`;
      if (this.cards.length < 3) { this.toolbar.className = 'fc-toolbar fc-toolbar--min'; this.toolbar.innerHTML = count; return; }
      const withFilters = this.showFilters();
      const defs = this.visibleDefs();
      const stock = defs.find((d) => d.toggle);
      const bar = withFilters ? defs.filter((d) => !d.toggle).map((d) => this.filterControl(d, 'pop')).join('') : '';
      const tog = withFilters && stock ? `<label class="fc-toggle"><input type="checkbox" data-fc-filter="stock" value="1"${(this.state.f.stock || []).length ? ' checked' : ''}><span class="fc-toggle__ui" aria-hidden="true"></span>${esc(stock.label)}</label>` : '';
      const n2 = this.activeCount();
      this.toolbar.className = 'fc-toolbar';
      this.toolbar.innerHTML = count + (withFilters ? `<div class="fc-filterbar" role="group" aria-label="${esc(u.filters)}">${bar}${tog}</div><button type="button" class="fc-btn fc-btn--line fc-open-filters" data-fc-open-filters aria-haspopup="dialog"><svg viewBox="0 0 24 24" aria-hidden="true" class="fc-ico"><path d="M4 7h10m4 0h2M4 17h4m4 0h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg>${esc(u.filters)}${n2 ? ` <span class="fc-count">${n2}</span>` : ''}</button>` : '') + this.sortSelect('bar');
    }

    renderActives() {
      const chips = [];
      Object.keys(this.state.f).forEach((id) => (this.state.f[id] || []).forEach((v) => {
        const def = this.defs[id]; if (!def) return;
        const txt = def.toggle ? def.label : `${def.label}: ${def.label_of(v)}`;
        chips.push(`<li><button type="button" class="fc-active" data-fc-remove="${id}" data-value="${esc(v)}" aria-label="${esc(fmt(this.ui.remove, { f: txt }))}">${esc(txt)}<span aria-hidden="true">×</span></button></li>`);
      }));
      if (!chips.length) { this.actives.innerHTML = ''; return; }
      const note = this.fromGuide ? `<p class="fc-guide-note">${esc(this.ui.g_note)} <a href="#cum-alegi">${esc(this.ui.g_change)}</a></p>` : '';
      this.actives.innerHTML = `<div class="fc-actives"><p class="fc-sr" id="fc-act-${this.cfg.sectionId}">${esc(this.ui.active)}</p><ul aria-labelledby="fc-act-${this.cfg.sectionId}">${chips.join('')}</ul><button type="button" class="fc-reset" data-fc-reset>${esc(this.ui.reset)}</button></div>${note}`;
    }

    shortcutList() {
      const list = (this.cfg.shortcuts || []).map((s) => ({ label: s.label, set: { [s.filter]: s.values.map((v) => (s.filter === 'size' ? sizeKeys(v)[0] : v.trim())) } }));
      const from = this.cfg.shortcutsFrom;
      if (from && from !== 'none' && this.defs[from]) this.facetAll(this.defs[from]).forEach((o) => list.push({ label: o.label, set: { [from]: [o.value] } }));
      return list;
    }
    facetAll(def) {
      const vals = new Set(); this.cards.forEach((c) => def.values(c).forEach((v) => vals.add(v)));
      const order = def.order || [];
      return Array.from(vals).sort((a, b) => (order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99)).map((v) => ({ value: v, label: def.label_of(v) }));
    }

    renderShortcuts() {
      if (!this.shortcutsBox) return;
      const list = this.shortcutList();
      if (!list.length || this.cards.length < 3) { this.shortcutsBox.innerHTML = ''; return; }
      const same = (set) => Object.keys(set).every((k) => (this.state.f[k] || []).slice().sort().join('|') === set[k].slice().sort().join('|')) && this.activeCount() === Object.values(set).reduce((n, v) => n + v.length, 0);
      const btn = (label, set, n) => {
        const on = set ? same(set) : this.activeCount() === 0;
        return `<li><button type="button" class="fc-chip${on ? ' is-on' : ''}" aria-pressed="${on}" data-fc-shortcut='${esc(JSON.stringify(set || {}))}'>${esc(label)} <span class="fc-chip__n">${n}</span></button></li>`;
      };
      const items = list.map((s) => { const n = this.cards.filter((c) => this.matches(c, { f: s.set })).length; return n ? btn(s.label, s.set, n) : ''; }).join('');
      this.shortcutsBox.innerHTML = `<nav class="fc-shortcuts" aria-label="${esc(this.ui.shortcuts)}"><ul>${btn(this.ui.all, null, this.cards.length)}${items}</ul></nav>`;
    }

    renderEmpty(n) {
      this.empty.hidden = n > 0;
      if (n > 0) return;
      const tips = [];
      Object.keys(this.state.f).forEach((id) => (this.state.f[id] || []).forEach((v) => {
        const st = { f: JSON.parse(JSON.stringify(this.state.f)) };
        st.f[id] = st.f[id].filter((x) => x !== v);
        const k = this.cards.filter((c) => this.matches(c, st)).length;
        if (k) tips.push({ id, v, k });
      }));
      tips.sort((a, b) => b.k - a.k);
      $('[data-fc-empty-tips]', this.empty).innerHTML = tips.slice(0, 3).map((t) => `<li><button type="button" class="fc-link-btn" data-fc-remove="${t.id}" data-value="${esc(t.v)}">${esc(fmt(this.ui.without, { v: this.defs[t.id].label_of(t.v), n: t.k + ' ' + this.plural(t.k) }))}</button></li>`).join('');
    }

    renderDrawer(n) {
      const u = this.ui;
      const defs = this.visibleDefs();
      const stock = defs.find((d) => d.toggle);
      this.drawer.innerHTML = `<div class="fc-dr__head"><h2 id="fc-dr-title-${this.cfg.sectionId}">${esc(u.filters)}</h2><button type="button" class="fc-dr__x" data-fc-close-drawer aria-label="${esc(u.close)}">×</button></div>` +
        `<div class="fc-dr__body">${this.sortSelect('dr')}${defs.filter((d) => !d.toggle).map((d) => this.filterControl(d, 'dr')).join('')}${stock ? `<label class="fc-toggle fc-toggle--dr"><input type="checkbox" data-fc-filter="stock" value="1"${(this.state.f.stock || []).length ? ' checked' : ''}><span class="fc-toggle__ui" aria-hidden="true"></span>${esc(stock.label)}</label>` : ''}</div>` +
        `<div class="fc-dr__foot"><button type="button" class="fc-btn fc-btn--line" data-fc-reset${this.activeCount() ? '' : ' disabled'}>${esc(u.reset)}</button><button type="button" class="fc-btn fc-btn--primary" data-fc-close-drawer>${esc(fmt(u.show_n, { n: n + ' ' + this.plural(n) }))}</button></div>`;
    }

    // ---------- focus și anunțuri ----------
    focusKey(el) {
      if (el.matches('input[data-fc-filter]')) return { sel: `input[data-fc-filter="${el.dataset.fcFilter}"][value="${CSS.escape(el.value)}"]`, inDrawer: !!el.closest('[data-fc-drawer]') };
      if (el.matches('select[data-fc-sort]')) return { sel: '#' + CSS.escape(el.id) };
      return null;
    }
    restoreFocus(k) { const scope = k.inDrawer ? this.drawer : k.inDrawer === false ? this.toolbar : this.root; const el = $(k.sel, scope); if (el) el.focus({ preventScroll: true }); }
    announce(msg) { this.status.textContent = ''; setTimeout(() => { this.status.textContent = msg; }, 50); }
    focusCount() { const c = $('[data-fc-count]', this.root); if (c) c.focus({ preventScroll: true }); }
    scrollToGallery() { const g = $('[data-fc-gallery]', this.root); if (g) g.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); }

    openPop(pop, focusFirst) {
      this.closePops(pop);
      if (!pop) return;
      const b = $('.fc-pop__btn', pop), p = $('.fc-pop__panel', pop);
      b.setAttribute('aria-expanded', 'true'); p.hidden = false;
      p.classList.toggle('is-right', p.getBoundingClientRect().right > window.innerWidth - 12);
      if (focusFirst) { const f = $('input:not([disabled])', p); if (f) f.focus(); }
    }
    closePops(except) {
      $$('.fc-pop', this.root).forEach((p) => { if (p === except) return; const b = $('.fc-pop__btn', p); if (b.getAttribute('aria-expanded') === 'true') { b.setAttribute('aria-expanded', 'false'); $('.fc-pop__panel', p).hidden = true; } });
    }

    setValues(id, values) { if (values && values.length) this.state.f[id] = values; else delete this.state.f[id]; }
    toggleValue(id, v, on) { const cur = this.state.f[id] || []; this.setValues(id, on ? cur.concat(cur.includes(v) ? [] : [v]) : cur.filter((x) => x !== v)); }
    reset() { this.state.f = {}; this.fromGuide = false; }

    applyGuide(set, sort) {
      this.state.f = {};
      Object.keys(set).forEach((k) => this.setValues(k, set[k]));
      if (sort) this.state.sort = sort;
      this.fromGuide = true;
      this.render(true, { announce: true });
      this.scrollToGallery();
      this.focusCount();
    }
    countFor(set) { return this.cards.filter((c) => this.matches(c, { f: set })); }

    // ---------- selecția mărimii ----------
    openChoose(btn) {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      if (desktop()) {
        const open = panel.hidden;
        this.closeQA(panel);
        panel.hidden = !open; btn.setAttribute('aria-expanded', String(open));
        if (open) { const r = $('input:not([disabled])', panel); if (r) r.focus(); }
        return;
      }
      this.closeQA();
      panel.fcHome = { parent: panel.parentNode, next: panel.nextSibling, btn };
      const card = btn.closest('[data-fc-card]');
      const img = $('.fc-card__img', card);
      this.sheet.innerHTML = `<div class="fc-sheet__head"><div class="fc-sheet__p">${img ? `<img src="${img.currentSrc || img.src}" width="56" height="56" alt="">` : ''}<div><h2>${esc(card.dataset.name)}</h2><p>${esc(($('.fc-card__color', card) || {}).textContent || '')} · ${esc(($('.fc-price__now', card) || {}).textContent.replace(/^\S+\s/, '') || '')}</p></div></div><button type="button" class="fc-dr__x" data-fc-close-sheet aria-label="${esc(this.ui.close)}">×</button></div>`;
      this.sheet.appendChild(panel);
      panel.hidden = false;
      this.sheet.fcPanel = panel;
      this.sheet.showModal();
      const r = $('input:not([disabled])', panel); if (r) r.focus();
    }
    restorePanel() {
      const panel = this.sheet.fcPanel;
      if (!panel || !panel.fcHome) return;
      panel.hidden = true;
      panel.fcHome.parent.insertBefore(panel, panel.fcHome.next);
      const btn = panel.fcHome.btn;
      this.sheet.fcPanel = null;
      return btn;
    }
    closeQA(except) {
      $$('[data-fc-qa]', this.grid).forEach((qa) => {
        if (qa === except || qa.closest('.fc-card--single')) return;
        if (!qa.hidden) { qa.hidden = true; const b = $(`[aria-controls="${qa.id}"]`, this.root); if (b) b.setAttribute('aria-expanded', 'false'); }
      });
    }

    // ---------- încărcare progresivă ----------
    async loadMore(btn) {
      const next = btn.dataset.next;
      if (!next) return;
      btn.disabled = true;
      try {
        const url = next + (next.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(this.cfg.sectionId);
        const html = await (await fetch(url, { credentials: 'same-origin' })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cells = $$('[data-fc-grid] > .fc-cell', doc);
        const before = this.cards.length;
        cells.forEach((c) => this.grid.appendChild(document.importNode(c, true)));
        this.readCards();
        this.defs = this.buildDefs();
        const newBtn = $('[data-fc-more]', doc);
        const nav = $('[data-fc-pag]', this.root), newNav = $('[data-fc-pag]', doc);
        if (nav && newNav) nav.replaceWith(document.importNode(newNav, true));
        if (!newBtn) { const b = $('[data-fc-more]', this.root); if (b) b.remove(); }
        const page = (next.match(/[?&]page=(\d+)/) || [])[1];
        if (page) { const q = new URLSearchParams(location.search); q.set('page', page); history.replaceState(history.state, '', location.pathname + '?' + q.toString()); }
        this.render(false, { announce: true });
        const first = this.cards[before];
        if (first && !first.cell.hidden) { const l = $('.fc-card__title a', first.el); if (l) l.focus(); }
      } catch (e) {
        window.location.href = next;
      }
    }

    // ---------- header fix ----------
    syncSticky() {
      // Headerul temei este fixat prin secțiunea care îl conține (position: sticky), nu prin <header>.
      const header = document.querySelector('[is="sticky-header"]') || document.querySelector('sticky-header');
      const candidates = [];
      for (let el = header; el && el !== document.body; el = el.parentElement) candidates.push(el);
      const set = () => {
        let h = 0;
        for (const el of candidates) {
          const cs = getComputedStyle(el);
          if (cs.position === 'sticky' || cs.position === 'fixed') {
            const r = el.getBoundingClientRect();
            if (r.top <= 1 && r.bottom > 0 && cs.visibility !== 'hidden') h = Math.max(h, Math.round(r.bottom));
          }
        }
        this.root.style.setProperty('--fc-sticky-top', h + 'px');
      };
      set();
      window.addEventListener('scroll', () => { if (!this._st) { this._st = requestAnimationFrame(() => { this._st = null; set(); }); } }, { passive: true });
      window.addEventListener('resize', set);
    }

    // ---------- evenimente ----------
    bind() {
      const root = this.root;
      root.addEventListener('click', (e) => {
        const t = e.target;
        const pb = t.closest('.fc-pop__btn');
        if (!t.closest('.fc-pop')) this.closePops();
        if (pb) { const pop = pb.closest('.fc-pop'); if (pb.getAttribute('aria-expanded') === 'true') this.closePops(); else this.openPop(pop, false); return; }
        const sc = t.closest('[data-fc-shortcut]');
        if (sc) { this.reset(); const set = JSON.parse(sc.dataset.fcShortcut); Object.keys(set).forEach((k) => this.setValues(k, set[k])); this.render(true, { announce: true }); return; }
        const rem = t.closest('[data-fc-remove]');
        if (rem) { this.toggleValue(rem.dataset.fcRemove, rem.dataset.value, false); this.fromGuide = this.fromGuide && this.activeCount() > 0; this.render(true, { announce: true }); const nx = $('.fc-active', root); if (nx) nx.focus(); else this.focusCount(); return; }
        if (t.closest('[data-fc-reset]')) { this.reset(); this.render(true, { announce: true }); if (this.drawer.open) { const f = $('input,select', this.drawer); if (f) f.focus(); } else this.focusCount(); return; }
        if (t.closest('[data-fc-open-filters]')) { this.renderDrawer(this.cards.filter((c) => this.matches(c, this.state)).length); this.drawer.fcReturn = t.closest('[data-fc-open-filters]'); this.drawer.showModal(); const f = $('input,select', this.drawer); if (f) f.focus(); return; }
        if (t.closest('[data-fc-close-drawer]')) { this.drawer.close(); return; }
        const ch = t.closest('[data-fc-choose]');
        if (ch) { e.stopPropagation(); this.openChoose(ch); return; }
        const qc = t.closest('[data-fc-qa-close]');
        if (qc) { const qa = qc.closest('[data-fc-qa]'); qa.hidden = true; const b = $(`[aria-controls="${qa.id}"]`, root); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); } return; }
        if (t.closest('[data-fc-close-sheet]')) { this.sheet.close(); return; }
        const more = t.closest('[data-fc-more]');
        if (more) { this.loadMore(more); return; }
        if (!t.closest('.fc-card')) this.closeQA();
      });
      root.addEventListener('change', (e) => {
        const t = e.target;
        if (t.matches('input[data-fc-filter]')) {
          const id = t.dataset.fcFilter;
          if (id === 'stock') this.setValues('stock', t.checked ? ['1'] : []); else this.toggleValue(id, t.value, t.checked);
          this.fromGuide = false;
          this.render(true, { keepPop: true, announce: true });
        } else if (t.matches('select[data-fc-sort]')) {
          this.state.sort = t.value;
          this.render(true, { announce: true });
        } else if (t.matches('.fc-sizes input[type="radio"]')) {
          const form = t.closest('form');
          const b = $('[data-fc-add]', form);
          if (b) { b.disabled = false; b.textContent = fmt(this.ui.add_size, { s: t.dataset.label }); }
        }
      });
      root.addEventListener('submit', (e) => {
        if (this.sheet.open && this.sheet.contains(e.target)) setTimeout(() => this.sheet.close(), 0);
      }, true);
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || this.drawer.open || this.sheet.open) return;
        const pb = $('.fc-pop__btn[aria-expanded="true"]', root);
        if (pb) { this.closePops(); pb.focus(); return; }
        const qa = $$('[data-fc-qa]', this.grid).find((q) => !q.hidden && !q.closest('.fc-card--single'));
        if (qa) { qa.hidden = true; const b = $(`[aria-controls="${qa.id}"]`, root); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); } }
      });
      this.drawer.addEventListener('close', () => { const b = $('[data-fc-open-filters]', root) || this.drawer.fcReturn; if (b && document.contains(b)) b.focus(); });
      this.sheet.addEventListener('close', () => { const b = this.restorePanel(); if (b) b.focus(); });
      [this.drawer, this.sheet].forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));
      document.addEventListener('product-ajax:added', () => { this.closeQA(); if (this.sheet.open) this.sheet.close(); });
      window.addEventListener('popstate', () => { this.state = this.fromURL(); this.render(false); });
    }
  }

  // ---------- ghidul „Cum alegi?” (secțiune separată) ----------
  const Guide = {
    form: null,
    cat() { const r = document.querySelector('[data-fc-root]'); return r && r.fcCat; },
    selection() {
      if (!this.form) return null;
      const set = {}; let sort = null, link = null, any = false;
      $$('fieldset', this.form).forEach((fs) => {
        const r = $('input:checked', fs); if (!r) return;
        any = true;
        const f = r.dataset.filter, vals = (r.dataset.values || '').split(',').map((v) => v.trim()).filter(Boolean);
        if (f && f !== 'none') set[f] = f === 'size' ? vals.map((v) => sizeKeys(v)[0]) : vals;
        if (r.dataset.sort) sort = r.dataset.sort;
        if (r.dataset.link) link = { href: r.dataset.link, label: r.dataset.linkLabel };
      });
      return any ? { set, sort, link } : null;
    },
    update() {
      const cat = this.cat(); if (!this.form || !cat) return;
      const live = $('[data-fc-guide-live]', this.form), btn = $('button[type="submit"]', this.form), extra = $('[data-fc-guide-extra]', this.form);
      const sel = this.selection();
      if (!sel) { live.textContent = cat.ui.g_prompt; btn.disabled = true; extra.innerHTML = ''; return; }
      const list = cat.countFor(sel.set);
      const names = Array.from(new Set(list.map((c) => c.name)));
      live.innerHTML = list.length ? `<strong>${esc(fmt(cat.ui.g_match, { n: list.length }))}</strong>: ${esc(names.slice(0, 5).join(', '))}${names.length > 5 ? '…' : ''}` : `<strong>${esc(cat.ui.g_none)}</strong>`;
      btn.disabled = !list.length;
      extra.innerHTML = sel.link ? `<a class="fc-link" href="${esc(sel.link.href)}">${esc(sel.link.label)}</a>` : '';
    },
    init() {
      this.form = document.querySelector('[data-fc-guide-form]');
      if (!this.form || this.form.fcBound) return;
      this.form.fcBound = true;
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('reset', () => setTimeout(() => this.update(), 0));
      this.form.addEventListener('submit', (e) => { e.preventDefault(); const sel = this.selection(); const cat = this.cat(); if (sel && cat) cat.applyGuide(sel.set, sel.sort); });
      this.update();
    },
  };

  // ---------- acordeoane: deschise pe desktop, restrânse pe mobil ----------
  let foldMode = null;
  function syncFolds(force) {
    const mode = desktop() ? 'd' : 'm';
    if (mode === foldMode && !force) return;
    foldMode = mode;
    $$('.fe-cat .fc-info__b').forEach((d, i) => { d.open = mode === 'd' || i === 0; });
    $$('.fe-cat .fc-fold').forEach((d) => { d.open = mode === 'd'; });
  }
  document.addEventListener('click', (e) => { const s = e.target.closest('.fe-cat .fc-info__b > summary, .fe-cat .fc-fold > summary'); if (s && desktop()) e.preventDefault(); }, true);
  window.addEventListener('resize', () => syncFolds());

  function init(scope) {
    $$('[data-fc-root]', scope || document).forEach((r) => { if (!r.fcCat) new Cat(r); });
    Guide.form = null; Guide.init();
    syncFolds(true);
  }
  window.FeCat = { init, Guide };
  window.FeCatGuide = Guide;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
